import { render, staticRenderFns } from "./role-info.vue?vue&type=template&id=22dc2961"
import script from "./role-info.vue?vue&type=script&lang=ts"
export * from "./role-info.vue?vue&type=script&lang=ts"
import style0 from "./role-info.vue?vue&type=style&index=0&id=22dc2961&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports